import { AuthenticateService } from 'src/services/authenticate.service';
import { DocumentService } from 'src/services/document.service';
import { PacientService } from 'src/services/pacient.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalController, ToastController, LoadingController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-carteira-vacinacao',
  templateUrl: './modal-carteira-vacinacao.component.html',
  styleUrls: ['./modal-carteira-vacinacao.component.scss'],
})
export class ModalCarteiraVacinacaoComponent implements OnInit {

  titulo = 'Adicionar um familiar';

  skeletonLoading = false;
  showfotoUser = false;
  language: string;
  showAdd = false;
  photobas64: any;
  urlQr = '';
  android = true;
  load = true;
  loadIdioma = false;
  type = 'pdf';
  url: any;
  data = {};
  tipo: any;

  constructor(
    private modalController: ModalController,
    private pacient: PacientService,
    private document: DocumentService,
    private translate: TranslateService,
    private auth: AuthenticateService,
    private toastController: ToastController,
    private loadingCtrl: LoadingController
  ) {
    this.data = JSON.parse(localStorage.getItem('evt_vacina'));
  }

  ngOnInit() { }

  ionViewDidEnter() {
    this.language = localStorage.getItem('LANGUAGE');
    if (!this.language) {
      this.language = 'pt';
    }

    this.translate.setDefaultLang(this.language);


    this.loadGeral();
  }

  async loadGeral() {

    let server = JSON.parse(localStorage.getItem('app_icp_token'));

    this.url = {
      url: await this.pacient.urlCaderneta(this.language),
      httpHeaders: {
        'Authorization': 'Bearer ' + this.auth.getAuthorizationToken(),
        "X-Authorization-Server": 'Bearer ' + server.access_token

      }
    };
  }

  async tratarErro() {
    const toast = await this.toastController.create({
      cssClass: 'modal-toast',
      message: 'Não foi possível carregar o documento. Tente novamente mais tarde.',
      position: 'top',
      duration: 4000
    });
    await toast.present();
  }

  callBackFn(evt) {
    this.load = false;
  }

  async idiomaSelected(value) {
    this.language = value;
    await this.loadGeral();
    this.loadIdioma = true;
    this.load = true;
    setTimeout(() => {

      this.loadIdioma = false;
    }, 200)
  }

  async download() {
    const loading = await this.loadingCtrl.create();
    await loading.present();
    const valid = await this.auth.verifyTokenValido();
    if (valid === true) {
      this.document.downloadVacinaCarteira();

      await loading.dismiss();
    }
  }

  fechar() {
    this.modalController.dismiss();
  }

}
